import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, Fields, reduxForm, SubmissionError } from 'redux-form';

import {
  DialogActions,
  DialogContent,
} from 'components/common/Dialog';
import Typography from '@material-ui/core/Typography';
import Button from 'components/common/Button';
import TextField from 'components/fields/TextField';
import SelectAutosuggestField from 'components/fields/SelectAutosuggestField';
import HCPCCOdesTextareaField from 'components/fields/HCPCCOdesTextareaField';
import CheckboxField from 'components/fields/CheckboxField';
import FormError from 'components/common/FormError';
import Radio from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroupField from 'components/fields/RadioGroupField';
import AutosuggestField from 'components/fields/AutosuggestField';
import UploadField from 'components/fields/UploadField';
import DatepickerField from 'components/fields/DatepickerField';
import InventoryStockLineCreateEditTotalPriceFields from
  'components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditTotalPriceFields';
import InventoryStockLineCreateEditTotalUnitsFields from
  'components/inventory/InventoryStockLineCreateEditDialog//InventoryStockLineCreateEditTotalUnitsFields';
import InventoryStockLineCreateEditUnitPriceFields from
  'components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditUnitPriceFields';
import InventoryStockLineCreateEditRetailPriceFields from
  'components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditRetailPriceFields';
import InventoryStockLineCreateEditUnitProfitFields from 
  'components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditUnitProfitFields';

import { createInventory, updateInventory } from 'redux/modules/inventory';
import {
  createInventoryStockLine,
  updateInventoryStockLine,
} from 'redux/modules/inventoryStockLine';
import {
  requestFetchVendors,
  requestSearchVendors,
} from 'redux/modules/vendors';
import {
  requestFetchInventoryCategories,
  requestSearchInventoryCategories,
} from 'redux/modules/inventoryCategories';
import {
  requestFetchInventoryConditions,
  requestSearchInventoryConditions,
} from 'redux/modules/inventoryConditions';
import {
  requestFetchInventoryWarehouses,
  requestSearchInventoryWarehouses,
} from 'redux/modules/inventoryWarehouses';
import {
  requestFetchFacilities,
  requestSearchFacilities,
} from 'redux/modules/facilities';
import { requestSearchHCPCSCodes } from 'redux/modules/hcpcsCodes';
import { accountLoginFail } from 'redux/modules/account';

import { uniq } from 'lodash';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';
import objectDiff from 'utils/objectDiff';
import imageFileTypes from 'config/imageFileTypes';
import dateFormat from 'config/dateFormat';

import InventoryCreateEditTable from './InventoryCreateEditTable';

const styles = theme => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
  gridActions: {
    position: 'absolute',
    left: 16,
    width: 'auto',
    marginLeft: 0,
    marginRight: 0,
  },
  typography: {
    paddingBottom: 2,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

function formValidate(values) {
  const errors = {};
  switch (values['Supply Type']) {
    case 'Boxes':
      if (!values['Price per Box']
        && (values['Boxes Quantity'] || values['Units in Box'])) {
        errors['Price per Box'] = 'Field is required';
      }
      if (!values['Boxes Quantity']
        && (values['Price per Box'] || values['Units in Box'])) {
        errors['Boxes Quantity'] = 'Field is required';
      }
      if (!values['Units in Box']
        && (values['Boxes Quantity'] || values['Price per Box'])) {
        errors['Units in Box'] = 'Field is required';
      }
      if (!values['Price per Box']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Price per Box'] = 'Field is required';
      }
      if (!values['Boxes Quantity']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Boxes Quantity'] = 'Field is required';
      }
      if (!values['Units in Box']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Units in Box'] = 'Field is required';
      }
      break;
    case 'Kcal Units':
      if (!values['Price per Box'] && (values['Boxes Quantity']
        || values['Units in Box'])) {
        errors['Price per Box'] = 'Field is required';
      }
      if (!values['Boxes Quantity'] && (values['Price per Box']
        || values['Units in Box'])) {
        errors['Boxes Quantity'] = 'Field is required';
      }
      if (!values['Units in Box'] && (values['Boxes Quantity']
        || values['Price per Box'])) {
        errors['Units in Box'] = 'Field is required';
      }
      if (!values['Calories Per Unit'] && (values['Boxes Quantity']
        || values['Price per Box'] || values['Units in Box'])) {
        errors['Calories Per Unit'] = 'Field is required';
      }
      if (!values['Price per Box']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Price per Box'] = 'Field is required';
      }
      if (!values['Boxes Quantity']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Boxes Quantity'] = 'Field is required';
      }
      if (!values['Units in Box']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Units in Box'] = 'Field is required';
      }
      if (!values['Calories Per Unit']
        && (values['Facility ID'] || values['Expiration Date'])) {
        errors['Calories Per Unit'] = 'Field is required';
      }
      break;
    default:
      if (values['Price per Unit'] && !values['Units Quantity']) {
        errors['Units Quantity'] = 'Field is required';
      }
      if (values['Units Quantity'] && !values['Price per Unit']) {
        errors['Price per Unit'] = 'Field is required';
      }
      if (values['Facility ID'] && !values['Units Quantity']) {
        errors['Units Quantity'] = 'Field is required';
      }
      if (values['Facility ID'] && !values['Price per Unit']) {
        errors['Price per Unit'] = 'Field is required';
      }
      if (values['Expiration Date'] && !values['Units Quantity']) {
        errors['Units Quantity'] = 'Field is required';
      }
      if (values['Expiration Date'] && !values['Price per Unit']) {
        errors['Price per Unit'] = 'Field is required';
      }
  }
  if (values['HCPC Codes'].length === 0) {
    return {
      ...errors,
      'HCPC Codes': { text: 'Field is required' },
    };
  }
  return Object.keys(errors).length > 0 ? errors : undefined;
}

function asyncValidate(values, dispatch, props) {
  const HCPCSCodes = [].concat(...values['HCPC Codes']);
  if (HCPCSCodes.length === 0) {
    return Promise.reject({
      'HCPC Codes': {
        text: 'Codes are empty',
      },
      _error: {
        'HCPC Codes': {
          text: 'Codes are empty',
        },
      },
    });
  }
  const duplicateHCPCSCodes = uniq(HCPCSCodes.filter((HCPCSCode, index, array) =>
    array.filter(item =>
      item === HCPCSCode).length > 1));
  if (duplicateHCPCSCodes.length > 0) {
    return Promise.reject({
      'HCPC Codes': {
        codes: duplicateHCPCSCodes,
        text: 'Code is duplicated',
      },
    });
  }
  const lastHCPCSCode = HCPCSCodes[HCPCSCodes.length - 1];
  let HCPCSCodeErrors =
    (props.error && props.error['HCPC Codes'] && props.error['HCPC Codes'].codes)
      ? props.error['HCPC Codes'].codes
      : [];
  const errorText = 'Incorrect code';
  HCPCSCodeErrors = HCPCSCodeErrors.filter(item => HCPCSCodes.indexOf(item) !== -1);

  if (HCPCSCodeErrors.indexOf(lastHCPCSCode) !== -1) {
    return Promise.reject({
      'HCPC Codes': {
        codes: HCPCSCodeErrors,
        text: errorText,
      },
      _error: {
        'HCPC Codes': {
          codes: HCPCSCodeErrors,
          text: errorText,
        },
      },
    });
  }

  return requestSearchHCPCSCodes({
    filters: [
      {
        name: 'HCPC S Code',
        operation: 'eq',
        val: lastHCPCSCode,
      },
    ],
    limit: 1,
    offset: 0,
  }).then((res) => {
    if (res.count === 0) {
      HCPCSCodeErrors.push(lastHCPCSCode);
    } else {
      props.onHCPCSCodeAdd(res.data[0]);
    }

    if (HCPCSCodeErrors.length) {
      // eslint-disable-next-line no-throw-literal
      throw {
        'HCPC Codes': {
          codes: HCPCSCodeErrors,
          text: errorText,
        },
        _error: {
          'HCPC Codes': {
            codes: HCPCSCodeErrors,
            text: errorText,
          },
        },
      };
    }
  }, (err) => {
    if (err.data.error === 'Need authorisation') {
      dispatch(accountLoginFail());
    }
    return err;
  });
}

function shouldAsyncValidate({
  initialized,
  trigger,
  pristine,
  blurredField,
}) {
  if (blurredField !== 'HCPC Codes') {
    return false;
  }
  switch (trigger) {
    case 'change':
      return true;
    case 'blur':
      return true;
    case 'submit':
      return !pristine || !initialized;
    default:
      return false;
  }
}

function onChange(values, dispatch, props, prevValues) {
  if (values['Selected Category Name']
    && values['Selected Category Name'] !== values['Category Name']) {
    dispatch(props.change('Category ID', ''));
  }

  if (values['Selected Condition Name']
    && values['Selected Condition Name'] !== values['Condition Name']) {
    dispatch(props.change('Condition ID', ''));
  }

  if (values['Selected Warehouse Location']
    && values['Selected Warehouse Location'] !== values['Warehouse Location']) {
    dispatch(props.change('Warehouse ID', ''));
  }

  if (values['Facility ID']
    && values['Selected Facility Name'] !== values['Facility Name']) {
    dispatch(props.change('Facility ID', ''));
  }

  if (values['Category Name']
    && values['Category Name'] === 'Enteral'
    && values['Category Name'] !== prevValues['Category Name']) {
    dispatch(props.change('Supply Type', 'Kcal Units'));
  }
}

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues, {
      ...formValues['Do not override'] !== undefined ? { 'Can Updated': !formValues['Do not override'] } : {},
      ...formValues['HCPC Codes'] ? { 'HCPC Codes': values['HCPC Codes'] } : {},
      ...formValues.Image ? { Image: values.Image } : {},
      ...formValues['Category ID'] === '' ? { 'Category ID': null } : {},
      ...formValues['Condition ID'] === '' ? { 'Condition ID': null } : {},
      ...formValues['Warehouse ID'] === '' ? { 'Warehouse ID': null } : {},
      ...formValues['Retail Price']
        ? { 'Retail Price': Number(formValues['Retail Price'].replace(/[$,]/g, '')) } : {},
      ...formValues['Retail Price'] === ''
        ? { 'Retail Price': null } : {},
      ...formValues['Calories Per Unit'] === ''
        ? { 'Calories Per Unit': null } : {},
      ...formValues['Units in Box'] ? {
        'Quantity In Case': formValues['Units in Box'],
      } : {},
    });

    switch (formValues['Supply Type']) {
      case 'Boxes':
        if (formValues['Price per Box'] && formValues['Units in Box']) {
          normalizedValues.Price = Number(formValues['Price per Box'].replace(/[$,]/g, '')) / formValues['Units in Box'];
        }
        if (formValues['Boxes Quantity'] && formValues['Units in Box']) {
          normalizedValues.Quantity = formValues['Boxes Quantity'] * formValues['Units in Box'];
        }
        break;
      case 'Kcal Units':
        if (formValues['Price per Box']
          && formValues['Units in Box']
          && formValues['Calories Per Unit']) {
          normalizedValues.Price = (Number(formValues['Price per Box'].replace(/[$,]/g, ''))
            / formValues['Units in Box']
            / formValues['Calories Per Unit']) * 100;
        }
        if (formValues['Boxes Quantity']
          && formValues['Units in Box']
          && formValues['Calories Per Unit']) {
          normalizedValues.Quantity = Math.round((formValues['Boxes Quantity']
            * formValues['Units in Box']
            * formValues['Calories Per Unit']) / 100);
        }
        break;
      default:
        if (formValues['Price per Unit']) {
          normalizedValues.Price = formValues['Price per Unit'].replace(/[$,]/g, '');
        }
        if (formValues['Units Quantity']) {
          normalizedValues.Quantity = formValues['Units Quantity'];
        }

        if (formValues.Image !== undefined && values.Image === null) {
          delete normalizedValues.Image;
          normalizedValues['Image ID'] = [];
        }
    }

    delete normalizedValues['Vendor Name'];
    delete normalizedValues['Vendor Email'];
    delete normalizedValues['Vendor Mobile Phone'];
    delete normalizedValues['Vendor Contact Person'];
    delete normalizedValues['Do not override'];
    delete normalizedValues['Supply Type'];
    delete normalizedValues['Price per Unit'];
    delete normalizedValues['Units Quantity'];
    delete normalizedValues['Boxes Quantity'];
    delete normalizedValues['Price per Box'];
    delete normalizedValues['Units in Box'];
    delete normalizedValues['Category Name'];
    delete normalizedValues['Condition Name'];
    delete normalizedValues['Warehouse Location'];
    delete normalizedValues['Selected Category Name'];
    delete normalizedValues['Selected Condition Name'];
    delete normalizedValues['Selected Warehouse Location'];
    delete normalizedValues['Facility Name'];
    delete normalizedValues['Selected Facility Name'];
    delete normalizedValues['Facility State'];
    delete normalizedValues['Facility Is Rural'];
    if (props.variant !== 'create') {
      delete normalizedValues['Facility ID'];
      delete normalizedValues['Warehouse ID'];
      delete normalizedValues['Is Retail Price For Claims'];
      delete normalizedValues['Is Retail Price For Self Pay'];
      delete normalizedValues['Calories Per Unit'];
      delete normalizedValues['Expiration Date'];
      delete normalizedValues['Quantity In Case'];
      delete normalizedValues['Retail Price'];
    }
    
    return normalizedValues;
  };

  const normalizeStockLineValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues, {
      ...formValues['Expiration Date'] === '' ? {
        'Expiration Date': null,
      } : {},
      ...formValues['Units in Box'] ? {
        'Quantity In Case': formValues['Units in Box'],
      } : {},
    });
    switch (formValues['Supply Type']) {
      case 'Boxes':
        if (formValues['Price per Box'] && formValues['Units in Box']) {
          normalizedValues.Price = Number(formValues['Price per Box'].toString().replace(/[$,]/g, '')) / formValues['Units in Box'];
        }
        if (formValues['Boxes Quantity'] && formValues['Units in Box']) {
          normalizedValues.Quantity = formValues['Boxes Quantity'] * formValues['Units in Box'];
        }
        break;
      case 'Kcal Units':
        if (formValues['Price per Box']
          && formValues['Units in Box']
          && formValues['Calories Per Unit']) {
          normalizedValues.Price = (Number(formValues['Price per Box'].toString().replace(/[$,]/g, ''))
            / formValues['Units in Box']
            / formValues['Calories Per Unit']) * 100;
        }
        if (formValues['Boxes Quantity']
          && formValues['Units in Box']
          && formValues['Calories Per Unit']) {
          normalizedValues.Quantity = Math.round((Number(formValues['Boxes Quantity'])
            * formValues['Units in Box']
            * formValues['Calories Per Unit']) / 100);
        }
        break;
      default:
        if (formValues['Price per Unit']) {
          normalizedValues.Price = formValues['Price per Unit'].toString().replace(/[$,]/g, '');
        }
        if (formValues['Units Quantity']) {
          normalizedValues.Quantity = formValues['Units Quantity'];
        }
    }
    if (formValues['Retail Price']) {
      normalizedValues['Retail Price'] = formValues['Retail Price'].toString().replace(/[$,]/g, '');
    } else {
      delete normalizedValues['Retail Price'];
    }
    delete normalizedValues['Supply Type'];
    delete normalizedValues['Price per Unit'];
    delete normalizedValues['Units Quantity'];
    delete normalizedValues['Boxes Quantity'];
    delete normalizedValues['Price per Box'];
    delete normalizedValues['Units in Box'];
    delete normalizedValues['Facility Name'];
    delete normalizedValues['Selected Facility Name'];
    delete normalizedValues['Facility State'];
    delete normalizedValues['Facility Is Rural'];
    delete normalizedValues['Category ID'];
    delete normalizedValues['Category Name'];
    delete normalizedValues['Do not override'];
    delete normalizedValues['HCPC Codes'];
    delete normalizedValues.Image;
    delete normalizedValues['Is Active'];
    delete normalizedValues.Model;
    delete normalizedValues['Selected Category Name'];
    delete normalizedValues['Vendor ID'];
    delete normalizedValues['Vendor Name'];
    delete normalizedValues['Product Name'];
    delete normalizedValues['Condition ID'];
    delete normalizedValues['Condition Name'];
    delete normalizedValues['Selected Condition Name'];
    delete normalizedValues['Warehouse Location'];
    delete normalizedValues['Selected Warehouse Location'];

    if (normalizedValues['Product ID']) {
      delete normalizedValues.ID;
    }

    if (normalizedValues['Stock Line ID']) {
      delete normalizedValues['Stock Line ID'];
    }

    if (normalizedValues['Calories Per Unit'] === props.initialValues['Calories Per Unit']) {
      delete normalizedValues['Calories Per Unit'];
    }

    return normalizedValues;
  };

  if (props.variant === 'stock-line-create') {
    if (props.editStockLineProduct) {
      const diffValues = normalizeValues(objectDiff(values, props.initialValues));
      return new Promise((resolve, reject) => {
        if (Object.keys(diffValues).length > 0) {
          dispatch(updateInventory({
            values: {
              ID: props.initialValues.ID,
              ...diffValues,
            },
            resolve,
            reject,
          }));
        } else {
          resolve();
        }
      }).then(res => new Promise((resolve, reject) => {
        dispatch(createInventoryStockLine({
          values: normalizeStockLineValues({
            ...values,
            ...values['Calories Per Unit'] !== props.initialValues['Calories Per Unit'] ? {
              'Calories Per Unit': values['Calories Per Unit'],
            } : {},
            'Product ID': values.ID,
          }),
          resolve,
          reject,
        }));
      }),
        (err) => {
          if (err.description) {
            throw new SubmissionError({ _error: err.description.indexOf('Unique check fail') !== -1
              ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err.description });
          }
          throw new SubmissionError({ _error: err.indexOf('Unique check fail') !== -1
            ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err });
        });
    } else {
      return new Promise((resolve, reject) => {
        dispatch(createInventoryStockLine({
          values: normalizeStockLineValues({
            ...values,
            ...values['Calories Per Unit'] !== props.initialValues['Calories Per Unit'] ? {
              'Calories Per Unit': values['Calories Per Unit'],
            } : {},
            'Product ID': values.ID,
          }),
          resolve,
          reject,
        }));
      }).then(res => res,
        (err) => {
          if (err.error) {
            throw new SubmissionError({ _error: err.error });
          }
          throw new SubmissionError(err);
        });
    }
  } else if (props.variant === 'stock-line-edit') {
    if (props.editStockLineProduct) {
      const diffValues = normalizeValues(objectDiff(values, props.initialValues));
      return new Promise((resolve, reject) => {
        if (Object.keys(diffValues).length > 0) {
          dispatch(updateInventory({
            values: {
              ID: props.initialValues.ID,
              ...diffValues,
            },
            resolve,
            reject,
          }));
        } else {
          resolve();
        }
      }).then(res => new Promise((resolve, reject) => {
        dispatch(updateInventoryStockLine({
          values: {
            ...normalizeStockLineValues({
              ...values,
              ...values['Calories Per Unit'] !== props.initialValues['Calories Per Unit'] ? {
                'Calories Per Unit': values['Calories Per Unit'],
              } : {},
              ID: values['Stock Line ID'],
            }),
            'Product ID': values.ID,
          },
          resolve,
          reject,
        }));
      }),
        (err) => {
          if (err.description) {
            throw new SubmissionError({ _error: err.description.indexOf('Unique check fail') !== -1
              ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err.description });
          }
          throw new SubmissionError({ _error: err.indexOf('Unique check fail') !== -1
            ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err });
        });
    } else {
      return new Promise((resolve, reject) => {
        dispatch(updateInventoryStockLine({
          values: {
            ...normalizeStockLineValues({
              ...values,
              ...values['Calories Per Unit'] !== props.initialValues['Calories Per Unit'] ? {
                'Calories Per Unit': values['Calories Per Unit'],
              } : {},
              ID: values['Stock Line ID'],
            }),
            'Product ID': values.ID,
          },
          resolve,
          reject,
        }));
      }).then(res => res,
        (err) => {
          if (err.error) {
            throw new SubmissionError({ _error: err.error });
          }
          throw new SubmissionError(err);
        });
    }

  } else if (props.variant === 'edit') {
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updateInventory({
        values: {
          ID: props.initialValues.ID,
          ...normalizeValues(diffValues),
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        if (err.description) {
          throw new SubmissionError({ _error: err.description.indexOf('Unique check fail') !== -1
            ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err.description });
        }
        throw new SubmissionError({ _error: err.indexOf('Unique check fail') !== -1
          ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err });
      });
  }

  return new Promise((resolve, reject) => {
    dispatch(createInventory({
      values: normalizeValues(values),
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.description) {
        throw new SubmissionError({ _error: err.description.indexOf('Unique check fail') !== -1
          ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err.description });
      }
      throw new SubmissionError({ _error: err.indexOf('Unique check fail') !== -1
        ? 'Sorry, but Product with such Name, Vendor and Model already exists' : err });
    });
}

const InventoryCreateEditForm = ({
  handleSubmit,
  error,
  className,
  change,
  classes,
  variant,
  onVendorCreate,
  onCategoryCreate,
  onConditionCreate,
  onWarehouseCreate,
  supplyType,
  categoryType,
  actions,
  onClose,
  dirty,
  submitting,
  submit,
  Product,
  editStockLineProduct,
  HCPCSCodes,
  initialValues,
  business,
}) => (
  <Fragment>
    <DialogContent withScrollbars>
      <form
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
        className={className}
      >
        {(error && typeof error === 'string') &&
          <Grid
            className={classes.grid}
            container
            spacing={24}
          >
            <Grid
              item
              xs={12}
            >
              <FormError>
                {error}
              </FormError>
            </Grid>
          </Grid>
        }
        {(['stock-line-create', 'stock-line-edit'].indexOf(variant) !== -1 && !editStockLineProduct) && (
          <InventoryCreateEditTable
            className={classes.table}
            {...Product}
          />
        )}
        {(['stock-line-create', 'stock-line-edit'].indexOf(variant) === -1 || editStockLineProduct) &&
          <Fragment>
            <Grid
              className={classes.grid}
              container
              spacing={24}
              alignItems="flex-start"
              justify="center"
            >
              <Grid
                item
                xs={12}
                sm={8}
              >
                <Grid
                  className={classes.grid}
                  container
                  spacing={24}
                >
                  <Grid
                    item
                    xs={12}
                  >
                    <Field
                      id="Product Name"
                      name="Product Name"
                      label="Product Name"
                      component={TextField}
                      validate={[validate.required]}
                      errorPlacement="bottom"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  className={classes.grid}
                  container
                  spacing={24}
                >
                  <Grid
                    item
                    xs={6}
                  >
                    <Field
                      id="Model"
                      name="Model"
                      label="Serial Number / Model"
                      component={TextField}
                      errorPlacement="bottom"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                  >
                    <Field
                      id="Vendor Name"
                      name="Vendor Name"
                      label="Vendor"
                      component={SelectAutosuggestField}
                      size="lg"
                      placeholder="-Select Vendor-"
                      alwaysRenderSuggestions
                      fullWidth
                      validate={[validate.required]}
                      renderSuggestionContent={suggestion => suggestion['Vendor Name']}
                      renderInputContent={suggestion => suggestion['Vendor Name']}
                      onSuggestionSelected={(suggestion) => {
                        change('Vendor ID', suggestion.ID);
                        change('Vendor Contact Person', suggestion['Contact Person']);
                        change('Vendor Email', suggestion.Email);
                        change('Vendor Mobile Phone', suggestion['Mobile Phone']);
                        return suggestion['Vendor Name'];
                      }}
                      fetchSuggestions={({ value, limit, offset }) => (
                        value.length > 0
                          ? requestSearchVendors({
                            filters: [
                              {
                                name: 'Vendor Name',
                                operation: 'startswith',
                                val: value,
                                case_sensitivity: false,
                              },
                            ],
                            limit,
                            offset,
                          }).then(res => res.data,
                            (err) => {
                              if (err.data.error === 'Need authorisation') {
                                actions.accountLoginFail();
                              }
                              return err;
                            })
                          : requestFetchVendors({
                            limit,
                            offset,
                          }).then(res => res.data,
                            (err) => {
                              if (err.data.error === 'Need authorisation') {
                                actions.accountLoginFail();
                              }
                              return err;
                            })
                      )}
                      onListAdornmentClick={onVendorCreate}
                      listAdornmentText="Add new"
                    />
                  </Grid>      
                </Grid>
                <Grid
                  className={classes.grid}
                  container
                  spacing={24}
                >
                  <Grid
                    item
                    xs={6}
                  >
                    <Field
                      id="Category Name"
                      name="Category Name"
                      label="Category Type"
                      component={AutosuggestField}
                      fullWidth
                      errorPlacement="top"
                      listWidth="auto"
                      renderSuggestionContent={suggestion => suggestion.Name}
                      onSuggestionSelected={(suggestion) => {
                        change('Category ID', suggestion.ID);
                        change('Selected Category Name', suggestion.Name);
                        return suggestion.Name;
                      }}
                      fetchSuggestions={({ value, limit, offset }) => (
                        value.length > 0
                          ? requestSearchInventoryCategories({
                            filters: [
                              {
                                name: 'Name',
                                operation: 'startswith',
                                val: value,
                                case_sensitivity: false,
                              },
                            ],
                            limit,
                            offset,
                          }).then(res => res.data,
                            (err) => {
                              if (err.data.error === 'Need authorisation') {
                                actions.accountLoginFail();
                              }
                              return err;
                            })
                          : requestFetchInventoryCategories({
                            limit,
                            offset,
                          }).then(res => res.data,
                            (err) => {
                              if (err.data.error === 'Need authorisation') {
                                actions.accountLoginFail();
                              }
                              return err;
                            })
                      )}
                      onListAdornmentClick={onCategoryCreate}
                      listAdornmentText="Add New"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                  >
                    <Field
                      id="Condition Name"
                      name="Condition Name"
                      label="Condition"
                      component={AutosuggestField}
                      fullWidth
                      errorPlacement="top"
                      listWidth="auto"
                      renderSuggestionContent={suggestion => suggestion.Name}
                      onSuggestionSelected={(suggestion) => {
                        change('Condition ID', suggestion.ID);
                        change('Selected Condition Name', suggestion.Name);
                        return suggestion.Name;
                      }}
                      fetchSuggestions={({ value, limit, offset }) => (
                        value.length > 0
                          ? requestSearchInventoryConditions({
                            filters: [
                              {
                                name: 'Name',
                                operation: 'startswith',
                                val: value,
                                case_sensitivity: false,
                              },
                            ],
                            limit,
                            offset,
                          }).then(res => res.data,
                            (err) => {
                              if (err.data.error === 'Need authorisation') {
                                actions.accountLoginFail();
                              }
                              return err;
                            })
                          : requestFetchInventoryConditions({
                            limit,
                            offset,
                          }).then(res => res.data,
                            (err) => {
                              if (err.data.error === 'Need authorisation') {
                                actions.accountLoginFail();
                              }
                              return err;
                            })
                      )}
                      onListAdornmentClick={onConditionCreate}
                      listAdornmentText="Add New"
                    />
                  </Grid>
                </Grid>
                <Grid
                  className={classes.grid}
                  container
                  spacing={24}
                  alignItems="flex-end"
                >
                  <Grid
                    item
                  >
                    <Field
                      id="Is Active"
                      name="Is Active"
                      label="Is Active"
                      component={CheckboxField}
                    />
                  </Grid>
                  <Grid
                    item
                  >
                    <Field
                      id="Do not override"
                      name="Do not override"
                      label="Do not override"
                      component={CheckboxField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={11}
                sm={4}
              >
                <Field
                  id="Image"
                  name="Image"
                  component={UploadField}
                  variant="image"
                  minWidth={300}
                  minHeight={300}
                  maxSize={10000000}
                  maxLength={7}
                  accept={imageFileTypes}
                  label={(
                    <Fragment>
                      Drag & Drop up to 7 images<br />
                      Minimum size is 300x300 px
                    </Fragment>
                  )}
                  fullWidth
                  showControls
                  controlsDirection="column"
                  showClearButton
                  multiple
                />
              </Grid>
            </Grid>
            <Grid
              className={classes.grid}
              container
              spacing={24}
            >
              <Grid
                item
                xs={12}
              >
                <Field
                  id="HCPC Codes"
                  name="HCPC Codes"
                  label="HCPCS Codes"
                  component={HCPCCOdesTextareaField}
                  disabled={variant === 'copy-add'}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Fragment>
        }
        {variant !== 'edit' &&
          <Fragment>
            <Grid
              className={classes.grid}
              container
              spacing={24}
            >
              <Grid item xs={12}>
                <Typography className={classes.typography}>
                  Inventory
                </Typography>
              </Grid>
            </Grid>
            <Grid
              className={classes.grid}
              container
              spacing={24}
            >
              <Grid item>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Supply Type</FormLabel>
                  <Field
                    name="Supply Type"
                    component={RadioGroupField}
                    direction="row"
                  >
                    <FormControlLabel
                      value="Units"
                      control={<Radio color="primary" />}
                      label="Units"
                      disabled={categoryType === 'Enteral' || initialValues['Supply Type'] === 'Kcal Units'}
                    />
                    <FormControlLabel
                      value="Boxes"
                      control={<Radio color="primary" />}
                      label="Case (Packs)"
                      disabled={categoryType === 'Enteral' || initialValues['Supply Type'] === 'Kcal Units'}
                    />
                    <FormControlLabel
                      value="Kcal Units"
                      control={<Radio color="primary" />}
                      label="Caloric Units"
                    />
                  </Field>
                </FormControl>
              </Grid>
            </Grid>
            {supplyType === 'Units' &&
              <Grid
                className={classes.grid}
                container
                spacing={24}
              >
                <Grid
                  item
                  xs={4}
                >
                  <Field
                    id="Units Quantity"
                    name="Units Quantity"
                    label="Units Quantity"
                    component={TextField}
                    normalize={normalize.number}
                    errorPlacement="top"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                >
                  <Field
                    id="Price per Unit"
                    name="Price per Unit"
                    label="Cost per Unit"
                    component={TextField}
                    normalize={normalize.price}
                    errorPlacement="top"
                    fullWidth
                  />
                </Grid>
              </Grid>
            }
            {supplyType === 'Boxes' &&
              <Fragment>
                <Grid
                  className={classes.grid}
                  container
                  spacing={24}
                >
                  <Grid
                    item
                    xs={4}
                  >
                    <Field
                      id="Boxes Quantity"
                      name="Boxes Quantity"
                      label="Quantity of Cases"
                      component={TextField}
                      normalize={normalize.number}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                  >
                    <Field
                      id="Units in Box"
                      name="Units in Box"
                      label="Units in Case"
                      component={TextField}
                      normalize={normalize.number}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                  >
                    <Field
                      id="Price per Box"
                      name="Price per Box"
                      label="Cost per Case"
                      component={TextField}
                      normalize={normalize.price}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>   
                </Grid>
              </Fragment>
            }
            {supplyType === 'Kcal Units' &&
              <Fragment>
                <Grid
                  className={classes.grid}
                  container
                  spacing={24}
                >
                  <Grid
                    item
                    xs={3}
                  >
                    <Field
                      id="Boxes Quantity"
                      name="Boxes Quantity"
                      label="Quantity of Cases"
                      component={TextField}
                      normalize={normalize.number}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  >
                    <Field
                      id="Units in Box"
                      name="Units in Box"
                      label="Units in Case"
                      component={TextField}
                      normalize={normalize.number}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  >
                    <Field
                      id="Price per Box"
                      name="Price per Box"
                      label="Cost per Case"
                      component={TextField}
                      normalize={normalize.price}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>    
                  <Grid
                    item
                    xs={3}
                  >
                    <Field
                      id="Calories Per Unit"
                      name="Calories Per Unit"
                      label="Calories Per Unit"
                      component={TextField}
                      normalize={normalize.float}
                      errorPlacement="top"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Fragment>
            }
            <Fields
              names={[
                'Retail Price',
                'Is Retail Price For Claims',
                'Is Retail Price For Self Pay',
              ]}
              component={InventoryStockLineCreateEditRetailPriceFields}
            />
            <Grid
              className={classes.grid}
              container
              spacing={24}
            >
              <Grid
                item
                xs={12}
                sm={4}
              >
                <Field
                  id="Facility Name"
                  name="Facility Name"
                  component={AutosuggestField}
                  label="Facility"
                  placeholder="-Select Facility-"
                  fullWidth
                  suggestionsPlacement="top"
                  renderSuggestionContent={suggestion => suggestion['Company Info']['Company Name']}
                  onSuggestionSelected={(suggestion) => {
                    change('Facility ID', suggestion.ID);
                    change('Selected Facility Name', suggestion['Company Info']['Company Name']);
                    change('Facility State', suggestion['Company Address'].State);
                    change('Facility Is Rural', suggestion['Company Address']['Is Rural']);
                    return suggestion['Company Info']['Company Name'];
                  }}
                  fetchSuggestions={({ value, limit, offset }) => (
                    value.length > 0
                      ? requestSearchFacilities({
                        filters: [
                          {
                            name: 'Facility Name',
                            operation: 'startswith',
                            val: value,
                            case_sensitivity: false,
                          },
                        ],
                        limit,
                        offset,
                      }).then(res => res.data,
                        (err) => {
                          if (err.data.error === 'Need authorisation') {
                            actions.accountLoginFail();
                          }
                          return err;
                        })
                      : requestFetchFacilities({
                        limit,
                        offset,
                      }).then(res => res.data,
                        (err) => {
                          if (err.data.error === 'Need authorisation') {
                            actions.accountLoginFail();
                          }
                          return error;
                        })
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
              >
                <Field
                  id="Warehouse Location"
                  name="Warehouse Location"
                  label="Warehouse Location"
                  component={AutosuggestField}
                  fullWidth
                  errorPlacement="top"
                  listWidth="auto"
                  suggestionsPlacement="top"
                  renderSuggestionContent={suggestion => suggestion.Location}
                  onSuggestionSelected={(suggestion) => {
                    change('Warehouse ID', suggestion.ID);
                    change('Selected Warehouse Location', suggestion.Location);
                    return suggestion.Location;
                  }}
                  fetchSuggestions={({ value, limit, offset }) => (
                    value.length > 0
                      ? requestSearchInventoryWarehouses({
                        filters: [
                          {
                            name: 'Location',
                            operation: 'startswith',
                            val: value,
                            case_sensitivity: false,
                          },
                        ],
                        limit,
                        offset,
                      }).then(res => res.data,
                        (err) => {
                          if (err.data.error === 'Need authorisation') {
                            actions.accountLoginFail();
                          }
                          return err;
                        })
                      : requestFetchInventoryWarehouses({
                        limit,
                        offset,
                      }).then(res => res.data,
                        (err) => {
                          if (err.data.error === 'Need authorisation') {
                            actions.accountLoginFail();
                          }
                          return err;
                        })
                  )}
                  onListAdornmentClick={onWarehouseCreate}
                  listAdornmentText="Add New"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
              >
                <Field
                  id="Expiration Date"
                  name="Expiration Date"
                  label="Expiration Date"
                  component={DatepickerField}
                  validate={[validate.date]}
                  normalize={normalize.date}
                  fullWidth
                  minDate="01/01/1900"
                  maxDate="01/01/2100"
                  dateFormat={dateFormat}
                  placeholder="mm/dd/yyyy"
                  endIcon="end"
                  errorPlacement="bottom"
                  datepickerPlacement="top-left"
                />
              </Grid>
            </Grid>
          </Fragment>
        }
      </form>
    </DialogContent>
    <DialogActions>
      {supplyType === 'Units' &&
        <Grid
          className={classes.gridActions}
          container
          spacing={24}
        >        
          <Fields
            names={[
              'Units Quantity',
              'Price per Unit',
            ]}
            component={InventoryStockLineCreateEditTotalPriceFields}
            variant="Units"
          />
          <Fields
            names={[
              'Price per Unit',
              'Retail Price',
              'HCPC Codes',
              'Facility State',
              'Facility Is Rural',
            ]}
            component={InventoryStockLineCreateEditUnitProfitFields}
            variant="Units"
            HCPCSCodes={HCPCSCodes}
            business={business}
          />
        </Grid>
      }
      {supplyType === 'Boxes' &&
        <Grid
          className={classes.gridActions}
          container
          spacing={24}
        >
          <Fields
            names={[
              'Boxes Quantity',
              'Units in Box',
            ]}
            component={InventoryStockLineCreateEditTotalUnitsFields}
            variant="Boxes"
          />
          <Fields
            names={[
              'Price per Box',
              'Units in Box',
            ]}
            component={InventoryStockLineCreateEditUnitPriceFields}
            variant="Boxes"
          />         
          <Fields
            names={[
              'Boxes Quantity',
              'Price per Box',
            ]}
            component={InventoryStockLineCreateEditTotalPriceFields}
            variant="Boxes"
          />
          <Fields
            names={[
              'Price per Box',
              'Units in Box',
              'Retail Price',
              'HCPC Codes',
              'Facility State',
              'Facility Is Rural',
            ]}
            component={InventoryStockLineCreateEditUnitProfitFields}
            variant="Boxes"
            HCPCSCodes={HCPCSCodes}
            business={business}
          />
        </Grid>
      }
      {supplyType === 'Kcal Units' &&
        <Grid
          className={classes.gridActions}
          container
          spacing={24}
        >
          <Fields
            names={[
              'Boxes Quantity',
              'Units in Box',
              'Calories Per Unit',
            ]}
            component={InventoryStockLineCreateEditTotalUnitsFields}
            variant="Kcal Units"
          />
          <Fields
            names={[
              'Price per Box',
              'Units in Box',
              'Calories Per Unit',
            ]}
            component={InventoryStockLineCreateEditUnitPriceFields}
            variant="Kcal Units"
          />         
          <Fields
            names={[
              'Boxes Quantity',
              'Price per Box',
            ]}
            component={InventoryStockLineCreateEditTotalPriceFields}
            variant="Boxes"
          />
          <Fields
            names={[
              'Price per Box',
              'Units in Box',
              'Calories Per Unit',
              'Retail Price',
              'HCPC Codes',
              'Facility State',
              'Facility Is Rural',
            ]}
            component={InventoryStockLineCreateEditUnitProfitFields}
            variant="Kcal Units"
            HCPCSCodes={HCPCSCodes}
            business={business}
          />
        </Grid>
      }
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          if (dirty || variant === 'copy') {
            submit();
          } else {
            onClose();
          }
        }}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        {variant === 'create' && 'Add'}
        {variant === 'edit' && 'Update'}
        {variant === 'copy' && 'Add'}
        {variant === 'copy-add' && 'Create'}
        {variant === 'stock-line-create' && 'Add'}
        {variant === 'stock-line-edit' && 'Update'}
      </Button>
    </DialogActions>
  </Fragment>
);

InventoryCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  onVendorCreate: PropTypes.func,
  onCategoryCreate: PropTypes.func,
  onConditionCreate: PropTypes.func,
  onWarehouseCreate: PropTypes.func,
  variant: PropTypes.oneOf(['create', 'edit', 'copy', 'copy-add', 'stock-line-create', 'stock-line-edit']),
  supplyType: PropTypes.oneOf(['Units', 'Boxes', 'Kcal Units']),
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

InventoryCreateEditForm.defaultProps = {
  className: '',
  variant: 'create',
  error: null,
  onVendorCreate: () => {},
  onCategoryCreate: () => {},
  onConditionCreate: () => {},
  onWarehouseCreate: () => {},
  supplyType: 'Units',
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'inventoryCreate',
  onSubmit,
  onChange,
  validate: formValidate,
  asyncValidate,
  shouldAsyncValidate,
})(withStyles(styles)(InventoryCreateEditForm)));



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryCreateEditDialog/InventoryCreateEditForm.js